// Shared easing curves for console motion.
//
// These were copy-pasted into seven files, which is how two different curves
// ended up describing "the console's reveal" — reveals in the setup wizard eased
// differently from reveals everywhere else with no intent behind it.
//
// Durations stay at the call site: they legitimately vary with the distance and
// size of the thing moving. The curves do not.

/** Decelerating and emphatic. The default for reveals and expansions. */
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const;

/** Gentler deceleration, for larger surfaces where expo reads as a snap. */
export const EASE_OUT_QUART = [0.25, 1, 0.5, 1] as const;
